import {TweenLite} from 'gsap';

const EventEmitter = require('eventemitter3');
const SizesUtils = require('../utils/SizesUtils');
const Utils = require('../utils/utils');

let instance = null;
const win = window;

const _start = instance => {
    if (instance.started) return;
    instance.started = true;
    win.addEventListener('mousemove', instance.handle);
    return instance;
}

const _stop = instance => {
    if (!instance.started) return;
    instance.started = false;
    win.removeEventListener('mousemove', instance.handle);
    return instance;
}

const _setXY = (a, x, y) => {
    if (typeof x === 'object') {
        a.x = x.x;
        a.y = x.y;
        return a;
    }
    a.x = x;
    a.y = y;
    return a;
}

const _changeXY = (a, x, y) => {
    if (typeof x === 'object') {
        a.x = x.x;
        a.y = x.y;
        TweenLite.to(a, 0.75, {x: x.x, y: x.y});
        return a;
    }
    TweenLite.to(a, 0.75, {x: x, y: y});
    return a;
}

const _handle = (evt, instance) => {
    let e = e || win.event;

    const winW = SizesUtils.winOffsetWidth();
    const winH = SizesUtils.winOffsetHeight();
    let relW = winW;
    let relH = winH;

    switch (instance.params.aspectTo) {
        case 'min':
            relW = relH = Math.min(winW, winH);
            break;
        case 'max':
            relW = relH = Math.max(winW, winH);
            break;
    }

    instance.normalizedWidth = relW;
    instance.normalizedHeight = relH;

    if (!e) return;
    if (e.originalEvent) { e = e.originalEvent; }

    const cx = winW * instance.params.center.x;
    const cy = winW * instance.params.center.y;
    const x = e.clientX;
    const y = e.clientY;

    if (!instance.initialized) {
        instance.initialized = true;
    }
    instance._setPosition(x, y);
    instance._setVector((x - cx) / relW, (y - cy) / relH);
    instance._setRelativePosition(x / relW, y / relH);

    instance.emit('update', instance);
}


const defaults = {
    // Defines the width/height values that are used to calculate relative values
    // 'both' - width and height separately => ellipse shaped
    // 'min' - the minimum value of width or height => circle shaped
    // 'max' - the maximum value of width or height => circle shaped
    aspectTo: 'both',
    center: {x: 0.5, y: 0.5}
}

// Target is window.
function MouseInteractionSingleton(config) {
    if (instance) return instance;
    instance = new EventEmitter();

    instance.params = Utils.extend(defaults, config);

    instance.initialized = false;
    instance.prevVector = {x: 0, y: 0};
    instance.prevPosition =  {x: 0, y: 0};
    instance.prevRelativePosition =  {x: 0, y: 0};
    instance.vector = {x: 0, y: 0};
    instance.position =  {x: 0, y: 0};
    instance.relativePosition =  {x: 0, y: 0};
    instance._setVector = (x, y) => { _setXY(instance.prevVector, instance.vector); _changeXY(instance.vector, x, y); };
    instance._setPosition = (x, y) => {  _setXY(instance.prevPosition, instance.position); _changeXY(instance.position, x, y); };
    instance._setRelativePosition = (x, y) => { _setXY(instance.prevRelativePosition, instance.relativePosition); _changeXY(instance.relativePosition, x, y); };

    instance.start = () => { return _start(instance); };
    instance.stop = () => { return _stop(instance); };
    instance.handle = evt => { return _handle(evt, instance); };
    instance.setParams = config => {
        instance.params = Utils.extend(defaults, instance.params, config);
    }

    // To set normalizedWidth and normalizedHeight:
    _handle(null, instance);

    return instance;
}

module.exports = MouseInteractionSingleton;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/interactions/MouseInteractionSingleton.js